import Information from './Information'
import Monitoring from './Monitoring'
import Setting from './Setting'
import Statement from '../ContentDeliveryNetwork/Statement'

const StorageLFD = {
    Information,
    Setting,
    Monitoring,
    Statement,
}

export default StorageLFD
